import { Badge, Box, Card, Divider, Heading, Text } from '@wix/design-system';
import { FunctionComponent } from 'react';
import css from './index.module.scss';
import { InfoCircleSmall } from '@wix/wix-ui-icons-common';
import { GenAnswerFooter } from './GenAnswerFooter';
import { ArticleSearchResultItem, GenAiArticleLink } from '../../types';
import { AIMediumIcon } from '../../icons/AIMediumIcon';
import { DATA_HOOKS } from '../../dataHooks';
import { useTranslation } from '@wix/wix-i18n-config';

type GeneratedAnswerProps = {
  searchQuestion: string;
  searchAnswer?: string;
  articleLinks: ArticleSearchResultItem[];
};

export const GeneratedAnswer: FunctionComponent<GeneratedAnswerProps> = ({
  searchQuestion,
  searchAnswer,
  articleLinks
}) => {
  const { t } = useTranslation();

  const genArticleLinks = (topFiveResults: ArticleSearchResultItem[]): GenAiArticleLink[] => {
    const topResultsLinks: GenAiArticleLink[] = [];
    topFiveResults.forEach((result) => {
      topResultsLinks.push({
        articleId: result.id,
        articleName: result.title,
        articleURL: result.url,
      });
    });
    return topResultsLinks;
  };

  return (
    <Box className={css.nextGenAnswerWrapper} dataHook={DATA_HOOKS.GEN_ANSWER_WRAPPER}>
      <Box direction="vertical" className={css.nextGenAnswerInnerWrapper}>
        <Box direction="vertical">
          <Box direction="horizontal" className={css.genAnswerHeader}>
            <Box direction="horizontal" display='inline' className={css.headerText}>
              <Box className={css.aiIconWrapper}>
                <AIMediumIcon />
              </Box>
              <Heading dataHook={DATA_HOOKS.GEN_ANSWER_HEADING}>
                <Text className={css.aiAnswer}>
                  {t('search-results-page.gen-answer.AI-answer')}
                </Text>
                <Text dataHook={DATA_HOOKS.GEN_ANSWER_QUESTION} className={css.searchQuestion}>{`for "${searchQuestion}"`}</Text>
              </Heading>
            </Box>
            <Box className={css.betaDisclaimerWrapper} dataHook={DATA_HOOKS.BETA_GEN_ANSWER}>
              <Badge className={css.betaDisclaimer} uppercase={false} skin="neutralLight" type="outlined">
                {t('search-results-page.gen-answer.beta')}
              </Badge>
            </Box>
          </Box>

          <Card className={css.answerContainerCard}>
            <Text className={css.answerText} size='medium' dataHook={DATA_HOOKS.GEN_ANSWER_ANSWER} weight="thin">{searchAnswer}</Text>
            <Box direction="horizontal" className={css.infoWrapper} gap='3px' dataHook={DATA_HOOKS.GEN_ANSWER_LEGAL_INFO}>
              <InfoCircleSmall />
              <Text size='tiny' secondary >
                {t('search-results-page.gen-answer.legal-info')}
              </Text>
            </Box>
            <Divider className={css.verticalDivider} />
            <GenAnswerFooter moreInfoArticles={genArticleLinks(articleLinks)}></GenAnswerFooter>
          </Card>
        </Box>
      </Box>
    </Box>);
};
